import React from "react";
import { Link } from "react-router-dom";
import { Building2, Truck, Shield, Briefcase, ArrowRight } from "lucide-react";
import useSeo from "../hooks/useSeo";

const CARDS = [
  {
    to: "/business/login",
    icon: Building2,
    title: "Erhvervskunde",
    body: "Adgang til B2B-portalen — forsendelser, CSV-import, tracking, faktura-grundlag, API-keys og webhooks.",
    testid: "login-card-business",
    accent: "border-brand-dark hover:border-brand-red",
  },
  {
    to: "/driver/login",
    icon: Truck,
    title: "Chauffør",
    body: "Driver PWA — dagens ruter, start/pause/slut rute, returregler og bekræftelse af afsluttede ruter.",
    testid: "login-card-driver",
    accent: "border-brand-dark hover:border-brand-red",
  },
  {
    to: "/employee/login",
    icon: Shield,
    title: "Medarbejder",
    body: "Internt EMA Kurer login for Operations, Finance og Support medarbejdere.",
    testid: "login-card-employee",
    accent: "border-brand-dark hover:border-brand-red",
  },
  {
    to: "/vognmand/login",
    icon: Briefcase,
    title: "Vognmand",
    body: "Vognmand-portal — egne ruter, afregning, payment status og download af afregnings-PDF/Excel.",
    testid: "login-card-subcontractor",
    accent: "border-brand-dark hover:border-brand-red",
  },
];

export default function LoginSelectorPage() {
  useSeo({
    title: "Login · EMA Kurer ApS",
    description: "Vælg din login-type — erhvervskunde, chauffør, medarbejder eller vognmand.",
    path: "/login",
  });

  return (
    <div className="min-h-screen bg-brand-bg2 py-16 px-5" data-testid="login-selector-page">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <div className="kicker text-brand-red">Login · EMA Kurer ApS</div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight mt-3 text-brand-dark">
            Vælg din portal
          </h1>
          <p className="text-brand-text2 mt-4 max-w-xl mx-auto">
            EMA Kurer har flere portaler afhængigt af din rolle. Vælg den der passer til dig.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="login-cards-grid">
          {CARDS.map((c) => (
            <Link
              key={c.to}
              to={c.to}
              data-testid={c.testid}
              className={`bg-white border-2 ${c.accent} p-7 transition-all group flex flex-col`}
            >
              <div className="w-12 h-12 bg-brand-dark text-white flex items-center justify-center mb-4 group-hover:bg-brand-red transition-colors">
                <c.icon size={20}/>
              </div>
              <div className="font-display font-bold text-2xl text-brand-dark">{c.title}</div>
              <p className="text-brand-text2 text-sm mt-3 flex-1">{c.body}</p>
              <div className="mt-5 flex items-center gap-2 text-brand-red font-bold text-sm">
                Log ind <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform"/>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center text-xs text-brand-text2">
          Privat kunde? Brug magic-link login via <Link to="/min-side" className="text-brand-red hover:underline">Min side</Link>.
        </div>
      </div>
    </div>
  );
}
